import { createArmorSubTheme, createDefaultThemeCached } from "./armor-system-QCYY7333.js";

// src/theme/useTheme.ts
import { useContext, useMemo } from "react";
import { ThemeContext } from "styled-components";
var useStyledComponentsTheme = function useStyledComponentsTheme() {
  return useContext(ThemeContext);
};
var useTheme = function useTheme(theme) {
  var styledComponentsTheme = useStyledComponentsTheme();
  return useMemo(function () {
    var _a;
    if (styledComponentsTheme) {
      if (!((_a = styledComponentsTheme.armor) == null ? void 0 : _a.$initialized)) {
        styledComponentsTheme.armor = createArmorSubTheme(styledComponentsTheme.armor);
      }
      return styledComponentsTheme;
    }
    return createDefaultThemeCached();
  }, [theme, styledComponentsTheme]);
};
export { useTheme };